import React from "react";
import { useParams, Navigate } from "react-router-dom";
import RegionHubTemplate from "@/components/templates/RegionHubTemplate";
import TownCoverageTemplate from "@/components/templates/TownCoverageTemplate";
import { REGION_PAGES } from "@/data/pageContent";
import { TOWN_PAGES } from "@/data/towns";

/**
 * /coverage/:slug — dispatches to either the RegionHubTemplate (for the four
 * region hubs) or the TownCoverageTemplate (for individual towns).
 */
const RegionPage = () => {
  const { slug } = useParams();
  if (REGION_PAGES[slug]) return <RegionHubTemplate data={REGION_PAGES[slug]} />;
  if (TOWN_PAGES[slug]) return <TownCoverageTemplate data={TOWN_PAGES[slug]} />;
  return <Navigate to="/" replace />;
};

export default RegionPage;
